function popup(state = {
    qrCodePop: '', openProductPop: false, imagePop: { status: 'hide' }, openDialog: false,
    openRejectServicePopup: { show: false }, openReferServicePopup: { show: false }, popupMenu: { show: false }, mapPop:{show:false}
}, action) {
    switch (action.type) {
        case "SET_QRPOPUP_STATUS":
            return {
                ...state,
                qrCodePop: action.data
            };
        case "SET_PRODUCT_POPUP":
            return {
                ...state,
                openProductPop: action.data
            }
        case "SET_IMAGE_POPUP":
            return {
                ...state,
                imagePop: action.data
            }
        case "SET_DIALOG":
            return {
                ...state,
                openDialog: action.data
            }
        case "SET_REJECTSERVICE_POPUP":
            return {
                ...state,
                openRejectServicePopup: action.data
            }
        case "SET_REFERSERVICE_POPUP":
            return {
                ...state,
                openReferServicePopup: action.data
            }
        case "SET_POPUP_MENU":
            return {
                ...state,
                popupMenu: action.data
            }
            case "MAP_POP":
                return {
                    ...state,
                    mapPop: action.data
                }            
        default:
            return state;
    }
}
export default popup;